import React, { useContext, useState, useEffect } from 'react'
import { toast } from 'react-hot-toast'

import { CALENDAR_CLOCK_ICON } from '../../../constants/urls'
import { DataContext } from '../../../context/DataContext'
import { useApi } from '../../../hooks/useApi'
import { formatDate, getDifferenceInDays, parseDate } from '../../../utils/dates'
import { downloadFromUrl } from '../../../utils/download'

import Button from '../../shared/Button'

import DiscountTicket from './DiscountTicket'

const DiscountBar: React.FC = () => {
  const {
    companyColor,
    loggedIn,
    setOpenAuthStep,
    sale,
    setShowQrCode,
    showQrCode,
    setQrCodeUrl
  } = useContext(DataContext)
  const { downloadDeliveryCode } = useApi()
  const [loadingQr, setLoadingQr] = useState<boolean>(false)
  const [formattedDate, setFormattedDate] = useState<string>('')
  const [days, setDays] = useState<number>(0)

  const isPointPickup =
    sale.deliveryType === 'clickAndCollect'

  const handleDownloadCode = async () => {
    if (!loggedIn) {
      setOpenAuthStep(1)
      return
    }
    setLoadingQr(true)
    const qrCode = await downloadDeliveryCode()
    if (qrCode.error) {
      toast.error('Error al descargar el código de entrega', {
        duration: 1800
      })
      setLoadingQr(false)
      return
    }
    downloadFromUrl(qrCode.qrCode, 'qr_codigo_entrega.png')
    setLoadingQr(false)
  }

  const handleShowQrCode = async () => {
    if (!loggedIn) {
      setOpenAuthStep(1)
      return
    }
    setLoadingQr(true)
    const qrCodeUrl = await downloadDeliveryCode()
    if (qrCodeUrl.error) {
      toast.error('Error al descargar el código de entrega', {
        duration: 1800
      })
      setLoadingQr(false)
      return
    }
    setQrCodeUrl(qrCodeUrl.qrCode)
    setLoadingQr(false)
    setShowQrCode(true)
  }

  useEffect(() => {
    const receivedDate = parseDate(sale.packageHistory[sale.packageHistory.length - 1].date, 1)
    const expirationDate = new Date(
      receivedDate.setDate(receivedDate.getDate() + (sale.totalPickupDays || 0) || 0)
    )
    setFormattedDate(formatDate(expirationDate))
    const differenceInDays = getDifferenceInDays(new Date(), receivedDate)
    setDays(differenceInDays)
  }, [sale.packageHistory, sale.totalPickupDays])

  return (
    <div className='mt-6'>

      <div className='flex items-center justify-center gap-6 mb-2 bg-[#F7F7F7] p-4 rounded-xl'>
        <img src={`${CALENDAR_CLOCK_ICON}`} alt='expiration' className='w-6' />

        <div>
          <p className='text-sm font-semibold'>Tienes {days} días para retirar tu pedido</p>
          <p className='text-sm text-gray-500'>Fecha Límite: {formattedDate}</p>
        </div>
      </div>

      {isPointPickup ? (
        <div className='mb-4 rounded-xl bg-[#F7F7F7] p-4'>
          <p className='text-sm font-semibold'>Retiro en punto</p>
          <p className='mt-2 text-sm text-gray-500'>
            Para retirar tu compra, presenta tu carnet de identidad y tu orden de transporte en el punto de retiro.
          </p>
          <p className='mt-2 text-sm text-gray-500'>
            Orden de transporte:{' '}
            {sale.trackingNumber ? (
              <span className='font-bold text-gray-900'>{sale.trackingNumber}</span>
            ) : (
              <button
                type='button'
                onClick={() => setOpenAuthStep(1)}
                className='font-bold underline'
                style={{ color: companyColor }}
              >
                Ver N° de orden
              </button>
            )}
          </p>
        </div>
      ) : (
        <>
          <div className='h-8 mb-4 portrait:hidden landscape:block'>
            <Button
              disabled={loadingQr}
              text={loadingQr ? 'Descargando...' : 'Descargar código'}
              onClick={handleDownloadCode}
              companyColor={companyColor}
              dark
            />
          </div>

          {!showQrCode &&
          <div className='h-8 portrait:block landscape:hidden'>
            <Button
              disabled={loadingQr}
              text={loadingQr ? 'Cargando...' : 'Ver Código de entrega'}
              onClick={handleShowQrCode}
              companyColor={companyColor}
              dark
            />
          </div>}
        </>
      )}

      {sale.deliveryType === 'storePickup' && <div className='portrait:hidden landscape:block landscape:mb-2'>
        <DiscountTicket />
      </div>}
    </div>
  )
}

export default DiscountBar
